export function isMobileSafari() {
  return (
    /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document) // special case for iPad on iOS 13
  );
}

/**
 * @returns true if the pointer type might be reported as 'mouse' on mobile Safari but we suspect the user is actually
 *   using a touch device.
 */
export function willPointerTypeBeUnreliableDueToMobileSafari() {
  return (
    isMobileSafari() && (!window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches)
  );
}

/**
 * @returns true if the event is suspected to have been caused by a touch instead of a mouse. Reliable on most browsers,
 *  but unreliable on mobile Safari.
 */
export function isTouchEvent(event: MouseEvent | PointerEvent) {
  return (
    (event instanceof PointerEvent && event.pointerType !== 'mouse') || willPointerTypeBeUnreliableDueToMobileSafari()
  );
}
